<div class="w-full relative h-full">
  <div class="flex flex-col h-full">
    <div class="flex flex-row mx-3 py-4">
      <div class="flex flex-col w-full">
        <button *ngIf="isDemo" class="btn btn-sm btn-primary-outline w-full mt-4" (click)="openSwitchToFull()">
          <span i18n class="font-semibold">Demo račun</span>
        </button>

        <!--        <a [routerLink]="['/admin/dashboard']" i18n-title title="Namizje"-->
        <!--           *appIfPermission="[PermissionEnum.MENU_GLOBAL_DASHBOARD_VIEW]"-->
        <!--           routerLinkActive="active bg-primaryWashed text-primaryDark rounded hover:bg-primaryWashed"-->
        <!--           [routerLinkActiveOptions]="{exact: true}"-->
        <!--           class="vehicles rounded py-3 flex flex-row text-grayDark hover:no-underline hover:bg-grayNavi hover:text-primaryDark focus:no-underline relative fadeInFadeOut">-->
        <!--          <div class="px-4 text-lg w-12">-->
        <!--            <i class="fas fa-th-large opacity-75"></i>-->
        <!--          </div>-->
        <!--          <span i18n="Left sidebar menu item" class="font-bold pl-1 pr-3 relative text-sm"-->
        <!--                style="top: 2px">Namizje</span>-->
        <!--        </a>-->

        <ng-container *appIfCountryFeatureAvailable="AccountFlagEnum.IS_AVAILABLE_TRADING_HUB">
          <app-trading-hub-sidebar [isShrunk]="isShrunk"/>
        </ng-container>

        <app-sidebar-item
                *appIfPermission="[PermissionEnum.MENU_GLOBAL_VEHICLES_VIEW]"
                icon="fas fa-car"
                [label]="vehiclesSideBarItemLabel"
                [title]="vehiclesSideBarItemLabel"
                [route]="['/admin/vehicles/active']"
                [permission]="PermissionEnum.MENU_GLOBAL_VEHICLES_VIEW"
                [isShrunk]="isShrunk"
                [isSidebarToggled]="isSidebarToggled">
        </app-sidebar-item>

        <app-sidebar-item
                *appIfPermission="[PermissionEnum.TAB_VEHICLES_ADS_VIEW]"
                icon="fas fa-bullhorn"
                [title]="advertisingSideBarItemLabel"
                [label]="advertisingSideBarItemLabel"
                [route]="['/admin/vehicles/ads']"
                [permission]="PermissionEnum.TAB_VEHICLES_ADS_VIEW"
                [isShrunk]="isShrunk"
                [isSidebarToggled]="isSidebarToggled">
        </app-sidebar-item>

        <ng-container *appIfAccountFeatureFlag="AccountFlagEnum.CLIENTS_MODULE">
          <app-sidebar-item
                  *appIfPermission="[PermissionEnum.MENU_GLOBAL_CLIENTS_VIEW]"
                  icon="fas fa-users"
                  [title]="clientsSideBarItemLabel"
                  [label]="clientsSideBarItemLabel"
                  [route]="['/admin/clients/all']"
                  [permission]="PermissionEnum.MENU_GLOBAL_CLIENTS_VIEW"
                  [isShrunk]="isShrunk"
                  [isSidebarToggled]="isSidebarToggled">
          </app-sidebar-item>
        </ng-container>

        <ng-container *appIfAccountFeatureFlag="AccountFlagEnum.HAS_VIRTUAL_SALON_MODULE_ACCESS">
          <app-sidebar-item
                  *appIfPermission="[PermissionEnum.MENU_GLOBAL_VIRTUAL_SALON_VIEW]"
                  icon="fas fa-globe"
                  i18n-title title="Spletna stran"
                  i18n-label label="Spletna stran"
                  [route]="['/admin/virtual-salon']"
                  [permission]="PermissionEnum.MENU_GLOBAL_VIRTUAL_SALON_VIEW"
                  [showNewBadge]="true"
                  [isShrunk]="isShrunk"
                  [isSidebarToggled]="isSidebarToggled">
          </app-sidebar-item>
        </ng-container>

        <ng-container *appIfCountryFeatureAvailable="AccountFlagEnum.DOCUMENTS">
          <app-sidebar-item
                  *appIfPermission="[PermissionEnum.MENU_GLOBAL_DOCUMENTS_VIEW]"
                  icon="fas fa-file-contract"
                  [title]="documentsSideBarItemLabel"
                  [label]="documentsSideBarItemLabel"
                  [route]="['/admin/documents/templates']"
                  [permission]="PermissionEnum.MENU_GLOBAL_DOCUMENTS_VIEW"
                  [isShrunk]="isShrunk"
                  [isSidebarToggled]="isSidebarToggled">
          </app-sidebar-item>
        </ng-container>

        <ng-container *appIfCountryFeatureAvailable="AccountFlagEnum.ASSETS">
          <app-sidebar-item
                  *appIfPermission="[PermissionEnum.MENU_GLOBAL_ASSETS_VIEW]"
                  icon="fas fa-wrench"
                  [title]="assetsSideBarItemLabel"
                  [label]="assetsSideBarItemLabel"
                  [route]="['/admin/assets/all']"
                  [permission]="PermissionEnum.MENU_GLOBAL_ASSETS_VIEW"
                  [isShrunk]="isShrunk"
                  [isSidebarToggled]="isSidebarToggled">
          </app-sidebar-item>
        </ng-container>

        <ng-container *appIfCountryFeatureAvailable="AccountFlagEnum.FEATURE_FLAG_ADMINISTRATION_V2">
          <app-sidebar-toggle-item
                  *appIfPermission="[PermissionEnum.MENU_GLOBAL_ADMINISTRATION_VIEW]"
                  [icon]="'fas fa-file-invoice'"
                  [label]="administrationToggleItemLabel"
                  [title]="administrationToggleItemLabel"
                  [permission]="PermissionEnum.MENU_GLOBAL_ADMINISTRATION_VIEW"
                  [isShrunk]="isShrunk"
                  [isExpanded]="isSideMenuHighlighted(SideMenuEnum.Admininstration)"
                  [menuKey]="SideMenuEnum.Admininstration"
                  [notificationCount]="administrationBadgeCount"
                  [notificationTooltip]="administrationBadgeTooltip"
                  (toggled)="toggleSideMenu($event)">
          </app-sidebar-toggle-item>
        </ng-container>

        <ng-container *appIfCountryFeatureAvailable="AccountFlagEnum.FEATURE_FLAG_MARKET_STUDY">
          <app-sidebar-item
                  *appIfPermission="[PermissionEnum.MENU_GLOBAL_MARKET_STUDY_VIEW]"
                  icon="fas fa-chart-line"
                  [label]="valuationSideBarItemLabel"
                  [title]="valuationSideBarItemLabel"
                  [route]="['/admin/market-study']"
                  [permission]="PermissionEnum.MENU_GLOBAL_MARKET_STUDY_VIEW"
                  [isShrunk]="isShrunk"
                  [isSidebarToggled]="isSidebarToggled">
          </app-sidebar-item>
        </ng-container>

        <ng-container *appIfCountryFeatureAvailable="AccountFlagEnum.WARRANTIES">
          <app-sidebar-item
                  *appIfPermission="[PermissionEnum.MENU_GLOBAL_WARRANTIES_VIEW]"
                  icon="fas fa-file-medical"
                  [label]="warrantiesSideBarItemLabel"
                  [title]="warrantiesSideBarItemLabel"
                  [route]="['/admin/warranties/all']"
                  [permission]="PermissionEnum.MENU_GLOBAL_WARRANTIES_VIEW"
                  [isShrunk]="isShrunk"
                  [isSidebarToggled]="isSidebarToggled">
          </app-sidebar-item>
        </ng-container>


        <ng-container *appIfCountryFeatureAvailable="AccountFlagEnum.FEATURE_FLAG_FINANCING_V3">
          <app-sidebar-item
                  *appIfPermission="[PermissionEnum.MENU_GLOBAL_FINANCING_VIEW]"
                  icon="fas fa-money-check-alt"
                  [label]="financingSideBarItemLabel"
                  [title]="financingSideBarItemLabel"
                  [route]="['/admin/leasings/financing/providers']"
                  [permission]="PermissionEnum.MENU_GLOBAL_FINANCING_VIEW"
                  [isShrunk]="isShrunk"
                  [isSidebarToggled]="isSidebarToggled">
          </app-sidebar-item>
        </ng-container>

        <!-- <ng-container *appIfPermission="[PermissionEnum.MENU_GLOBAL_FINANCING_VIEW]">
           <button *appIfAccountFeatureFlag="[AccountFlagEnum.FEATURE_FLAG_FINANCING_V3]"
                   data-test="menu-financing-button"
                   class="rounded py-3 flex flex-row text-grayDark hover:no-underline hover:bg-grayNavi hover:text-primaryDark focus:no-underline relative fadeInFadeOut w-full"
                   [routerLink]="['/admin/leasings/financing/providers']"
                   [routerLinkActive]="'active text-primaryDark'">"-->
        <!--        (click)="toggleFinancingMenu()"-->

        <!--  <div class="px-4 text-lg w-12">
        <i class="fas fa-money-check-alt opacity-75"></i>
      </div>
      <span i18n="Left sidebar menu item" class="font-bold pl-1 pr-3 relative text-sm grow text-left"
            style="top: 2px">Financiranja</span>"-->

        <!--  <div class="px-2 grow-0">-->
        <!--    <div *ngIf="!financingMenuOpened">-->
        <!--      <i class="fas fa-chevron-down"></i>-->
        <!--    </div>-->

        <!--    <div *ngIf="financingMenuOpened">-->
        <!--      <i class="fas fa-chevron-up"></i>-->
        <!--    </div>-->
        <!--  </div>-->

        <!--  </button>-->
        <!--<div class="ml-8" *ngIf="financingMenuOpened">-->
        <!--  <a [routerLink]="['/admin/leasings/financing/providers']"-->
        <!--     i18n-title title="Leasings"-->
        <!--     routerLinkActive="active bg-primaryWashed text-primaryDark rounded hover:bg-primaryWashed"-->
        <!--     [routerLinkActiveOptions]="{ exact: true }"-->
        <!--     class="rounded py-3 flex flex-row text-grayDark hover:no-underline hover:bg-grayNavi hover:text-primaryDark focus:no-underline relative fadeInFadeOut">-->
        <!--    <span i18n="Left sidebar menu item" class="pl-1 pr-3 relative text-sm" style="top: 2px">Financiranja</span>-->
        <!--  </a>-->

        <!--  <a [routerLink]="['/admin/leasings/financing/providers/nlb']"-->
        <!--     i18n-title title="NLb Leasing"-->
        <!--     routerLinkActive="active bg-primaryWashed text-primaryDark rounded hover:bg-primaryWashed"-->
        <!--     class="rounded py-3 flex flex-row text-grayDark hover:no-underline hover:bg-grayNavi hover:text-primaryDark focus:no-underline relative fadeInFadeOut">-->
        <!--    <span i18n="Left sidebar menu item" class="pl-1 pr-3 relative text-sm" style="top: 2px">NLB Lease & Go</span>-->
        <!--  </a>-->
        <!--</div>-->
        <!--</ng-container>-->

        <ng-container *appIfAccountFeatureFlag="AccountFlagEnum.FEATURE_FLAG_ANALYTICS">
          <app-sidebar-toggle-item
                  *appIfPermission="[PermissionEnum.MENU_GLOBAL_BUSINESS_OVERVIEW_VIEW]"
                  [icon]="'fas fa-file-invoice'"
                  [label]="businessUnitsToggleItemLabel"
                  [title]="businessUnitsToggleItemLabel"
                  [permission]="PermissionEnum.MENU_GLOBAL_BUSINESS_OVERVIEW_VIEW"
                  [isShrunk]="isShrunk"
                  [isExpanded]="isSideMenuHighlighted(SideMenuEnum.BusinessOverview)"
                  [menuKey]="SideMenuEnum.BusinessOverview"
                  (toggled)="toggleSideMenu($event)">
          </app-sidebar-toggle-item>
        </ng-container>

      </div>
      <div class="bg-white ml-4 md:ml-3 h-full md:hidden">
        <div class="border-l border-grayLight h-full md:border-r"
             *ngIf="isSideMenuActive(SideMenuEnum.Admininstration)"
             (click)="toggleSideMenu(SideMenuEnum.Admininstration)">
          <app-administration-sidebar></app-administration-sidebar>
        </div>
        <div class="border-l border-grayLight h-full md:border-r"
             *ngIf="isSideMenuActive(SideMenuEnum.BusinessOverview)"
             (click)="toggleSideMenu(SideMenuEnum.BusinessOverview)">
          <div class="px-4 py-4">
            <h3 i18n="Left sidebar menu item title" class="overline text-gray">Pregled poslovanja</h3>

            <a [routerLink]="['/admin/business-overview/general-table-overview']" i18n-title title="Tabelaricni prikaz"
               *appIfPermission="[PermissionEnum.MENU_BUSINESS_OVERVIEW_TABLE_VIEW]"
               routerLinkActive="active bg-primaryWashed text-primaryDark rounded hover:bg-primaryWashed"
               class="rounded py-3 flex flex-row text-grayDark hover:no-underline hover:bg-grayNavi hover:text-primaryDark focus:no-underline relative fadeInFadeOut"
               data-test="menu-business-overview-table-view-button"
            >
              <span i18n="Left sidebar menu item" class="font-bold pl-1 pr-3 relative text-sm" style="top: 2px">Tabelarični prikaz</span>
            </a>

            <a [routerLink]="['/admin/business-overview/general-graphical-overview']" i18n-title title="Graficni prikaz"
               *appIfPermission="[PermissionEnum.MENU_BUSINESS_OVERVIEW_GRAPHS_VIEW]"
               routerLinkActive="active bg-primaryWashed text-primaryDark rounded hover:bg-primaryWashed"
               class="rounded py-3 flex flex-row text-grayDark hover:no-underline hover:bg-grayNavi hover:text-primaryDark focus:no-underline relative fadeInFadeOut"
               data-test="menu-business-overview-graph-view-button"
            >
              <span i18n="Left sidebar menu item" class="font-bold pl-1 pr-3 relative text-sm" style="top: 2px">Grafični prikaz</span>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="w-full">
      <!-- <div class="px-4 py-4 mt-6">
        <h3 i18n="Left sidebar menu item title" class="overline text-gray">Pomoč</h3>
      </div> -->

      <!-- <app-help-contact-us></app-help-contact-us> -->
    </div>

  </div>

  <div class="absolute bg-white h-full hidden md:block md:h-screen"
       style="left:100%; top:6px; z-index: 999;">
    <div class="border-l border-grayLight h-full md:border-r" *ngIf="isSideMenuActive(SideMenuEnum.Admininstration)"
         (click)="toggleSideMenu(SideMenuEnum.Admininstration)">
      <app-administration-sidebar></app-administration-sidebar>
    </div>
    <div class="border-l border-grayLight h-full md:border-r" *ngIf="isSideMenuActive(SideMenuEnum.BusinessOverview)"
         (click)="toggleSideMenu(SideMenuEnum.BusinessOverview)">
      <app-business-overview-sidebar></app-business-overview-sidebar>
    </div>
  </div>

  <ng-content></ng-content>
</div>
